import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";
import main from "./../../assets/images/boxOne.webp";

const PopupGiveCoupon = ({ isOpen, onClose, baseAmount }) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();

  if (!isOpen) return null;

  // Prevent closing when clicking inside the popup
  const handlePopupClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
        dir={direction}
        onClick={onClose}
      >
        {/* Popup Content */}
        <div
          onClick={handlePopupClick}
          className="relative w-[90%] max-w-lg md:py-12 py-8 md:px-8 px-6 text-center bg-yellow-50 shadow-lg animate-fadeIn"
        >
          <div
            className="absolute inset-0 z-0 w-full h-full transition-opacity duration-500"
            style={{
              backgroundImage: `url(${main})`,
              backgroundRepeat: "repeat",
              width: "auto",
              height: "auto",
              backgroundPosition: "center",
              opacity: 0.03,
            }}
          />
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute z-50 text-gray-500 top-3 right-3 hover:text-black"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>

          {/* Title */}
          <h2 className="relative z-50 mb-2 text-xl font-bold text-gray-900 md:text-2xl">
            {t("couponTitle")}
          </h2>

          {/* Subtitle */}
          <h2 className="relative z-50 text-xl font-bold text-gray-900 md:text-2xl">
            <span>{t("couponValue")}</span> <span>{baseAmount}</span>{" "}
            <span>{t("KWDValue")}</span>
          </h2>

          {/* Description */}
          <p className="relative z-50 my-6 text-sm leading-relaxed text-gray-700 md:my-8 md:text-base">
            {t("couponDescription")}
            <br />
            {t("couponLimitedOffer")}
          </p>

          {/* Yellow Button */}
          <button
            onClick={() => navigateWithLang("/registration")}
            className="relative z-50 w-full px-4 py-2 font-medium text-black transition-colors border border-custom-yellow bg-custom-yellow hover:bg-black hover:text-white"
          >
            {t("getMyCoupon")}
          </button>
        </div>
      </div>

      {/* Animation */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default PopupGiveCoupon;
